import { render, staticRenderFns } from "./Varia.vue?vue&type=template&id=1542d2ed&"
import script from "./Varia.vue?vue&type=script&lang=js&"
export * from "./Varia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports